import { getData } from './client'
import type { Notification } from './types'

/** 목록을 부르는 것이 곧 읽음 처리다 — 서버가 `openInbox()` 로 함께 처리한다. */
export function list(page = 1): Promise<Notification[]> {
  return getData<Notification[]>('/notifications', { params: { page } })
}

export function unreadCount(): Promise<{ unread: number }> {
  return getData<{ unread: number }>('/notifications/count')
}
